import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import apiRequest from "../../../../utils/admin/apiRequest";
import InputField from "../../../ui/form/InputField";
import FileInputField from "../../../ui/form/FileInputField";
import Button from "../../../ui/utils/Button";
import usePost from "../../../../hooks/api/usePost";
import Alert from "../../../ui/utils/Alert";
import CheckboxField from "../../../ui/form/CheckboxField";
import SelectField from "../../../ui/form/SelectField";
import useFetch from "../../../../hooks/api/useFetch";

const CreateCategory = ({ closeModal, callback }) => {
  const [preview, setPreview] = useState(null);
    const {
    error,
    isLoading: loading,
    post,
    serverErrors,
  } = usePost(apiRequest.createCategory);

  const { data, loading: categoryLoding } = useFetch({
    apiMethod: apiRequest.getMainCategory,
    body: { paginate: false, sortField: "name", sortOrder: "asc" },
    autoFetch: true,
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      image: null,
      removeBg: false,
      mainCategory: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      mainCategory: Yup.string().required("Main Category is required"),
      image: Yup.mixed()
        .required("Image is required")
        .test("fileType", "Invalid file type", (value) =>
          value
            ? ["image/jpeg", "image/png", "image/webp"].includes(value.type)
            : false
        ),
    }),
    onSubmit: async (values, { resetForm }) => {

      
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("mainCategory", values.mainCategory);
      formData.append("image", values.image);
      formData.append("removeBg", values.removeBg.toString());
      const response = await post({ data: { formData } });
      if (response?.response) {
        callback?.();
        resetForm();
        closeModal();
      }
    },
  });

  return (
    <div>
      <h2 className="p-4 text-lg font-semibold">Create Category  </h2>
      <div className="border-b" />

      <form onSubmit={formik.handleSubmit} className="text-sm">
        {error && <Alert message={error} type="error" />}
        <div className="p-4 space-y-4">
          <div className="grid grid-cols-2 gap-2">

            <InputField
              name="name"
              label="Category Name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched?.name && formik.errors.name}
              serverError={serverErrors?.name}
              placeholder="Enter category name"
            />




            <SelectField
              id="mainCategory"
              name="mainCategory"
              label="Select Main Category"
              options={data?.categories?.map((item) => ({
                value: item._id,
                label: item.name,
              }))}
              value={formik.values.mainCategory}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.mainCategory && formik.errors.mainCategory}
              serverError={serverErrors?.mainCategory}
              placeholder="Select Main Category"
            />


          </div>
          <FileInputField
            error={formik.touched.image && formik.errors.image}
            id="image"
            label="Image"
            accept="image/*"
            onChange={(e) => {
              const file = e.currentTarget.files?.[0] || null;
              formik.setFieldValue("image", file);
              setPreview(file ? URL.createObjectURL(file) : null);
            }}
          />
          {preview && (
            <img
              src={preview}
              alt="Preview"
              className="object-contain w-20 h-20 mt-2 border rounded"
            />
          )}
          <CheckboxField
            checked={formik.values.removeBg}
            name="removeBg"
            label=" Remove Background"
            id="removeBg"
            value={formik.values.removeBg}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.removeBg}
            error={formik.touched.removeBg && formik.errors.removeBg}
          />
        </div>

        <div className="border-b" />
        <div className="flex justify-end gap-2 p-4">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loadingText="Creating..."
            isLoading={loading}
          >
            Create
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CreateCategory;
